import axios from "axios";

export const registerEmail = async (email) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/register-email`,
        { email }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const verifyEmail = async (otp, email) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify-email`,
        { otp, email }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const signUp = async (
    firstName,
    lastName,
    organization,
    email,
    idNumber,
    country,
    address,
    phoneNumber,
    password,
    role,
    countryCode
  ) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/sign-up`, {
        firstName,
    lastName,
    organization,
    email,
    idNumber,
    country,
    address,
    phoneNumber,
    password,
    role,
    countryCode
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const login = async (
    email,
    password
  ) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/open/v1/log-in`,

         {
        email,
        password
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  
  export const forgotPassword = async (
    email
    ) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/forget-password`, {
        email
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  
  export const resetPassword = async (
    email,
    password
    ) => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/forget-password-reset`, {
        email,
        password
      });
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  export const resendOtp = async (email) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/resend-otp`,
        { email }
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };

   export const createAdmin = async (form ,token) => {
    
        if (!token) {
    throw new Error("No auth token found!");
  }
  
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },}
    try {
      const res = await axios.post(
        "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/create-admin",
        form, config 
      );
  
      return res;
    } catch (error) {
      console.log("ERROR", error);
    }
  };


export const deleteAdmin = async (id, token) => {
  if (!token) {
    throw new Error("No auth token found!");
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_API_URL}/admin/${id}`,
      config
    );
    return res.data; // return just the data
  } catch (error) {
    console.error("Delete Admin ERROR:", error.response?.data || error.message);
    throw error;
  }
};

export const listAdmin = async ( token) => {
  if (!token) {
    throw new Error("No auth token found!");
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(
      "http://api.dev.closecarbon.com/admin/v1/list-admin",
      config
    );
    return res.data; // return just the data
  } catch (error) {
    console.error("Delete Admin ERROR:", error.response?.data || error.message);
    throw error;
  }
};


export const getAdminById = async (id, token) => {
  if (!token) {
    throw new Error("No auth token found!");
  }
  if (!id) {
    throw new Error("No admin ID provided!");
  }

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/${id}`,
      config
    );
    return res.data;
  } catch (error) {
    console.error("Get Admin ERROR:", error.response?.data || error.message);
    throw error;
  }
};


